import { Search, X } from "lucide-react";

export default function SearchInput({ value, onChange, placeholder = "Søg…", testid = "search-input" }) {
    return (
        <div className="relative w-full sm:w-72">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
            <input
                type="text"
                data-testid={testid}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full h-10 pl-9 pr-9 rounded-full bg-white border border-slate-200 shadow-sm text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition-all"
            />
            {value && (
                <button
                    type="button"
                    onClick={() => onChange("")}
                    data-testid={`${testid}-clear`}
                    className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 inline-flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100"
                    aria-label="Ryd søgning"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            )}
        </div>
    );
}
